<app-nav-steps *ngIf="!isDetailsView"></app-nav-steps>
<app-loader *ngIf="isLoading"></app-loader>

<div *ngIf="!isLoading">
  <div *ngFor="let data of technicalDataArray; let i = index">
    <app-facilities-form
      [formIndex]="i"
      [showData]="showData"
      [facilitiesData]="data"
      [isReadOnly]="isReadOnly"
      [currentFormType]="currentFormType"
      [isMeterInstallation]="isMeterInstallation"
      [allowDelete]="technicalDataArray.length > 1"
      [applicationId]="applicationId"
      [isDetailsView]="isDetailsView"
      (onCloneTechnicalData)="onCloneTechnicalData($event)"
      (onDeleteTechnicalData)="onDeleteTechnicalData($event)"></app-facilities-form>
  </div>

  <div class="ui-g-12 submit-button-section text-center bottom-padding" *ngIf="!isReadOnly && !isDetailsView">
    <button
      pButton
      label="{{ 'basic-profile.jurisdiction.proceed' | translate | uppercase }}"
      class="submit-button"
      [disabled]="disableSubmitBtn()"
      (click)="submitForm()"></button>
  </div>
</div>
